<template>
    <v-container>
        <v-row v-if="label" class="v-label theme--light align-center">
            {{ label ? label : '' }}
            <v-btn
                v-if="!(listValue && listValue.length)"
                fab
                x-small
                color="primary"
                elevation="1"
                class="mx-3"
                @click="add"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-checkbox
                :required="required"
                :rules="rules"
                :value="!!listValue && listValue.length && !!listValue[0]"
                class="hidden-checkbox"
            ></v-checkbox>
        </v-row>
        <v-row>
            <v-col v-for="(item, index) in listValue" :cols="12" :key="`item-${labelAsKey}-${index}`">
                <v-row class="align-center">
                    <v-combobox
                        v-if="type === 'combobox'"
                        :ref="`extandableTextField${index}`"
                        :value="listValue[index]"
                        :items="items"
                        :hint="$t('profile.confirmNameEdit')"
                        @change="changeItem($event, index)"
                        @keydown.enter="add"
                        @blur="() => !listValue[index] && remove(index)"
                        @keydown.esc="() => !listValue[index] && remove(index)"
                    ></v-combobox>
                    <v-text-field
                        v-else
                        :ref="`extandableTextField${index}`"
                        :value="listValue[index]"
                        :rules="[(v) => type !== 'email' || /.+@.+/.test(v) || $t('common.formRules.email')]"
                        @change="changeItem($event, index)"
                        @keydown.enter="add"
                        @blur="() => !listValue[index] && remove(index)"
                        @keydown.esc="() => !listValue[index] && remove(index)"
                    ></v-text-field>
                    <v-btn fab x-small color="primary" elevation="1" class="mx-1" @click="remove(index)">
                        <v-icon>mdi-minus</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="listValue && index === listValue.length - 1"
                        fab
                        x-small
                        color="primary"
                        elevation="1"
                        class="mx-1"
                        @click="add"
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Vue from 'vue'
import snakeCase from 'lodash'
import { app } from '@/firebase'
export default Vue.extend({
    name: 'ExtendableList',
    props: {
        value: Array,
        type: String,
        label: String,
        required: Boolean,
        rules: Array,
        getItemFunc: String,
    },
    computed: {
        listValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
        labelAsKey() {
            return snakeCase(this.label)
        },
    },
    data: () => ({
        items: [],
    }),
    mounted() {
        if (this.type === 'combobox' && this.getItemFunc) {
            app.functions()
                .httpsCallable(this.getItemFunc)()
                .then((res) => {
                    if (res.data) {
                        this.items = res.data
                    }
                })
        }
    },
    methods: {
        changeItem(val, index) {
            this.listValue = [...this.listValue.slice(0, index), val, ...this.listValue.slice(index + 1)]
        },
        add() {
            this.listValue = [...this.listValue, '']
            if (this.listValue.length > 0) {
                this.$nextTick(() => {
                    const refName = `extandableTextField${this.listValue.length - 1}`
                    this.$refs[refName][0].focus()
                })
            }
        },
        remove(index) {
            this.listValue = [...this.listValue.slice(0, index), ...this.listValue.slice(index + 1)]
        },
    },
})
</script>

<style>
.hidden-checkbox .v-input__slot {
    display: none;
}

.hidden-checkbox .v-messages {
    margin-left: 12px;
    top: -8px;
}
</style>
